/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Exercise_Sheet_Add_To_DayInputs */

const en_us2_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add to ${i?.day}`)
};

const pt_br2_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ao ${i?.day}`)
};

const es_419_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar a ${i?.day}`)
};

const pt_pt2_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ao ${i?.day}`)
};

const fr_fr2_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter à ${i?.day}`)
};

const de_de2_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu ${i?.day} hinzufügen`)
};

const it_it2_exercise_sheet_add_to_day = /** @type {(inputs: Exercise_Sheet_Add_To_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi a ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Add to {day}" |
*
* @param {Exercise_Sheet_Add_To_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_add_to_day = /** @type {((inputs: Exercise_Sheet_Add_To_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Add_To_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_add_to_day(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_add_to_day(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_add_to_day(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_add_to_day(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_add_to_day(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_add_to_day(inputs)
	return en_us2_exercise_sheet_add_to_day(inputs)
});
export { exercise_sheet_add_to_day as "exercise-sheet.add_to_day" }